import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import "./sortableItem.css";
import { useViewport } from "../../helpers";

export const Item = React.forwardRef(({ id, ...props }, ref) => {
  return (
    <div id={id} ref={ref} {...props}>
      {props.children}
    </div>
  );
});

export function SortableItem(props) {
  const { width } = useViewport();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    setDraggableNodeRef,
  } = useSortable({ id: props.id });

  React.useEffect(() => {
    if (isDragging) {
      document.body.style.cursor = "grabbing";
    } else {
      document.body.style.cursor = "default";
    }
  }, [isDragging]);

  const style = {
    opacity: isDragging ? 0.6 : undefined,
    transform: CSS.Transform.toString(transform),
    transition,
    width: width < 960 || props.customWidth ? "auto" : "115px",
    color: "black",
    position: "relative",
    marginRight: props.customWidth ? "0" : width < 960 ? "0.5rem" : "1rem",
    padding: "5px",
  };

  const dragButtonStyle = {
    touchAction: "none", // prevent weird behavior on mobile
    position: "absolute",
    top: 0,
    left: 0,
  };

  const customWidthDragButtonStyle = {
    touchAction: "none", // prevent weird behavior on mobile
    position: "absolute",
    top: "50%",
    left: "15px",
    transform: "translateY(-50%)",
  };

  return (
    <Item ref={setNodeRef} id={props.id} style={style}>
      {props.children}
      {!props.disableDrag && (
        <button
          style={
            props.dragTopLeft
              ? dragButtonStyle
              : props.customWidth
              ? customWidthDragButtonStyle
              : dragButtonStyle
          }
          className="DragHandle"
          {...attributes}
          {...listeners}
          ref={setDraggableNodeRef}
        >
          <svg viewBox="0 0 20 20" width="12">
            <path
              fill="#fff"
              d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z"
            ></path>
          </svg>
        </button>
      )}
    </Item>
  );
}
